import React from "react";
import { PHASES } from "./eaImportApi";

export const EaPhaseStepper = ({ phase, status }) => {
  const idx = Math.max(0, PHASES.findIndex((p) => p.key === phase));
  const failed = status === "FAILED";
  return (
    <div className="flex items-center gap-1 flex-wrap" data-testid="ea-import-phases">
      {PHASES.map((p, i) => {
        const done = status === "COMPLETED" || i < idx;
        const current = i === idx && status === "PROCESSING";
        const cls = failed && i === idx
          ? "bg-red-100 text-red-700 border-red-200"
          : done
            ? "bg-emerald-50 text-emerald-700 border-emerald-200"
            : current
              ? "bg-purple-100 text-purple-800 border-purple-300 animate-pulse"
              : "bg-white text-slate-400 border-slate-200";
        return (
          <span key={p.key} className={`text-[10px] px-1.5 py-0.5 rounded border font-medium ${cls}`}>
            {p.label}
          </span>
        );
      })}
    </div>
  );
};

export default EaPhaseStepper;
